import React from "react";

import PlusIcon from "@uui/Plus";

import styled from "@mui/material/styles/styled";

import { ConnectedCalendarProvider } from "@app/common/auth/api";
import {
  CALENDAR_PROVIDERS,
  CALENDAR_PROVIDERS_BY_ID,
} from "@app/common/constants/providers";
import ROUTES from "@app/common/routes";

import IconButton from "@rui/IconButton";
import { Link } from "@rui/Link";
import Stack from "@rui/Stack";
import { Img } from "@rui/styles";

const ProviderIconContainer = styled(Stack)(({ theme }) => ({
  backgroundColor: theme.palette.shades.ghost[500],
  borderRadius: theme.corners.base,
  padding: theme.spaces.small,
}));

const AddProviderIconButton = styled(IconButton)(({ theme }) => ({
  backgroundColor: theme.palette.shades.ghost[500],
  borderRadius: theme.corners.base,
  padding: theme.spaces.small,
  height: "36px",
  width: "36px",
  "& .MuiSvgIcon-root": {
    color: theme.palette.shades.primary[500],
  },
}));

const ConnectedCalendars = ({
  connectedCalendarProviders,
}: {
  connectedCalendarProviders: ConnectedCalendarProvider[];
}) => {
  const canConnectAdditionalProvider =
    connectedCalendarProviders.length < CALENDAR_PROVIDERS.length;
  return (
    <>
      {connectedCalendarProviders.map((provider) => {
        const providerConfig = CALENDAR_PROVIDERS_BY_ID[provider.providerId];
        if (!providerConfig) return null;

        return (
          <ProviderIconContainer key={provider.providerId}>
            <Img src={providerConfig.icon} sx={{ height: "20px" }} />
          </ProviderIconContainer>
        );
      })}
      {canConnectAdditionalProvider && (
        <Link to={ROUTES.USER_SETTINGS_INTEGRATIONS}>
          <AddProviderIconButton>
            <PlusIcon />
          </AddProviderIconButton>
        </Link>
      )}
    </>
  );
};

export default ConnectedCalendars;
